"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlaybackType;
(function (PlaybackType) {
    PlaybackType[PlaybackType["Live"] = 0] = "Live";
    PlaybackType[PlaybackType["Vod"] = 1] = "Vod";
    PlaybackType[PlaybackType["Local"] = 2] = "Local";
    PlaybackType[PlaybackType["Live_Stb"] = 3] = "Live_Stb";
    PlaybackType[PlaybackType["Vod_Stb"] = 4] = "Vod_Stb";
    PlaybackType[PlaybackType["Sideloaded"] = 5] = "Sideloaded";
    PlaybackType[PlaybackType["Advert"] = 6] = "Advert";
})(PlaybackType = exports.PlaybackType || (exports.PlaybackType = {}));
var DrmType;
(function (DrmType) {
    DrmType[DrmType["PlayReady"] = 0] = "PlayReady";
    DrmType[DrmType["Widewine"] = 1] = "Widewine";
    DrmType[DrmType["VGC"] = 2] = "VGC";
})(DrmType = exports.DrmType || (exports.DrmType = {}));
var StreamFormatType;
(function (StreamFormatType) {
    StreamFormatType[StreamFormatType["Hss"] = 0] = "Hss";
    StreamFormatType[StreamFormatType["Hls"] = 1] = "Hls";
    StreamFormatType[StreamFormatType["Dash"] = 2] = "Dash";
    StreamFormatType[StreamFormatType["Mp4"] = 3] = "Mp4";
})(StreamFormatType = exports.StreamFormatType || (exports.StreamFormatType = {}));
